import React, {useContext, useEffect, useState} from "react";

import ButtonsAction from "./ButtonsAction";
import ButtonsShowBlock from "./ButtonsShowBlock";
import TranslationContext from "../../../context/TranslationContext";


const AuthContainer = ({setAuthorizedDevice}) => {
    const {getTranslation} = useContext(TranslationContext)
    const [mainShow, setMainShow] = useState(true)
    const [smsBtnShow, setSmsBtnShow] = useState(false)
    const [callBtnShow, setCallBtnShow] = useState(false)
    const [call800BtnShow, setCall800BtnShow] = useState(false)
    const [pinBtnShow, setPinBtnShow] = useState(false)
    const [midBtnShow, setMidBtnShow] = useState(false)
    const [voipBtnShow, setVoipBtnShow] = useState(false)

    const [externalAuthBtnShow, setExternalAuthBtnShow] = useState(false)

    const [externalUnit, setExternalUnit] = useState({})


    const handlerExtraAuthStart =() => {
        setMainShow(false)
        setExternalAuthBtnShow(true)
    }

    const handlerSmsAuthStart = () => {
        setMainShow(false); 
        setSmsBtnShow(true)
    }
    const handlerCallAuthStart = () => {
        setMainShow(false); 
        setCallBtnShow(true); 
    }
    const handlerCall800AuthStart = () => {
        setMainShow(false);
        setCall800BtnShow(true)
    }
    const handlerPinAuthStart = () => {
        setMainShow(false)
        setPinBtnShow(true)
    }
    const handlerMidAuthStart = () => {
        setMainShow(false)
        setMidBtnShow(true)
    }
    const handlerVoipAuthStart = () => {
        setMainShow(false)
        setVoipBtnShow(true)
    }


    const handlerBackBtn = () => {
        setMainShow(true)
        setSmsBtnShow(false)
        setCall800BtnShow(false)
        setCallBtnShow(false)
        setPinBtnShow(false)
        setMidBtnShow(false)
        setVoipBtnShow(false)
        setExternalAuthBtnShow(false)
    }

    useEffect(()=>{
        if (localStorage.getItem("_wh_call") !== null) {
            const tmp = JSON.parse(localStorage.getItem("_wh_call"))
            if (tmp.expire < Date.now()/1000) {
                tmp.type === 499 ? handlerCallAuthStart() : handlerCall800AuthStart()
            }
        }
    },[])


    return (
        <div className={!(mainShow) ? 'mh-350':''}>
            {
                mainShow && <>
                    <span style={{marginBottom: "1rem"}}>{getTranslation("select")}</span>
                    {/* Button handlers (сами кнопки)*/}
                    <ButtonsShowBlock
                        setExternalUnit={setExternalUnit}
                        handlerSmsAuthStart={handlerSmsAuthStart}
                        handlerCallAuthStart={handlerCallAuthStart}
                        handlerCall800AuthStart={handlerCall800AuthStart}
                        handlerPinAuthStart={handlerPinAuthStart}
                        handlerMidAuthStart={handlerMidAuthStart}
                        handlerVoipAuthStart={handlerVoipAuthStart}
                        handlerExtraAuthStart={handlerExtraAuthStart}
                    />
                </>
            }
            {/* Button Action Blocks (то что внутри кнопки)*/}
            <ButtonsAction
                setAccess={setAuthorizedDevice}
                external={externalUnit}
                call800BtnShow={call800BtnShow}
                callBtnShow={callBtnShow}
                midBtnShow={midBtnShow}
                pinBtnShow={pinBtnShow}
                smsBtnShow={smsBtnShow}
                voipBtnShow={voipBtnShow}
                extraBtnShow={externalAuthBtnShow}
                handlerBackBtn={handlerBackBtn}
            />
        </div>
    )
}

export default AuthContainer